'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProductImages } from './product-images';
import { ProductVariants } from './variants/product-variants';
import { ProductDetailPrice } from './product-detail-price';
import { ProductDetailAvailability } from './product-detail-availability';
import { ProductQuantity } from './product-quantity';

import { ProductPaymentMethods } from './product-payment-methods';

import { ProductBottomInfo } from './product-bottom-info';
import { ProductHeader } from './product-header';
import { Breadcrumbs } from '@eliadmin/core/src/components/homepage/breadcrumbs';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { CatalogueNavigationReady } from '@/components/catalogue-navigation';

export function ProductInfo() {
  const product = useVariantsStore(state => state.product) as ProductDetailData;

  return (
    <section
      className={cn(
        'custom-section',
        'gap-6 pb-6 pt-12 sm:gap-8 sm:pb-8 md:gap-10 md:pb-10 lg:gap-12 lg:pb-12',
      )}
    >
      <CatalogueNavigationReady slug={product.slug} />
      <div className={cn('custom-container')}>
        <Breadcrumbs breadcrumb={product.breadcrumb} product={product} />
      </div>
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start gap-8 md:flex-row md:justify-between lg:gap-12',
        )}
      >
        <CarouselProvider>
          <ProductImages />
        </CarouselProvider>
        <div className="flex w-full flex-col items-start justify-start gap-6 md:max-w-[680px]">
          <ProductHeader />
          <ProductVariants />
          <ProductDetailAvailability />
          <ProductDetailPrice />
          <ProductQuantity />
          <ProductPaymentMethods />
          <ProductBottomInfo />
        </div>
      </div>
    </section>
  );
}
